import {Component, Injector} from "@angular/core";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";

export interface DialogData_DeleteDialog extends MatDialogDataBaseInput {
	deleteTitle: string;
	deleteText: string;
	deleteButtonText?: string;
	cancelText?: string;
}

export interface DialogData_DeleteDialogOutput extends MatDialogDataBaseOutput {}

@Component({
	selector: "sim-delete-dialog-mat",
	templateUrl: "./delete-dialog-mat.component.html",
	styleUrls: ["./delete-dialog-mat.component.scss"],
	standalone: false,
})
export class DeleteDialogMatComponent extends BasicMaterialDialog<
	DeleteDialogMatComponent,
	DialogData_DeleteDialog,
	DialogData_DeleteDialogOutput
> {
	constructor(_injector: Injector) {
		super(_injector);
	}
}
